import React from 'react';
import moment from 'moment';
import useInterval from "use-interval";
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import RefreshIcon from '@material-ui/icons/Refresh';
import LoopIcon from '@material-ui/icons/Loop';
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import Fab from '@material-ui/core/Fab';

function getTimeRemaining(endtime) {
    const total = Date.parse(endtime) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    const days = Math.floor(total / (1000 * 60 * 60 * 24));

    return {
        total,
        days,
        hours,
        minutes,
        seconds
    };
}

function timeRemainingFormatted(endTime) {

    const timeRemaining = getTimeRemaining(endTime);
    var remaining = '';
    if (timeRemaining.days) {
        remaining += timeRemaining.days + ' day';
        if (timeRemaining.days > 1)
            remaining += 's';
        remaining += ' ';
    } if (timeRemaining.hours) {
        remaining += timeRemaining.hours + ' hour';
        if (timeRemaining.hours > 1)
            remaining += 's';
        remaining += ' ';
    } if (timeRemaining.minutes) {
        remaining += timeRemaining.minutes + ' minute';
        if (timeRemaining.minutes > 1)
            remaining += 's';
        remaining += ' ';
    } if (timeRemaining.seconds) {
        remaining += timeRemaining.seconds + ' second';
        if (timeRemaining.seconds > 1)
            remaining += 's';
        remaining += ' ';
    }


    return remaining;

}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    refreshButtonFullWidth: {
        width: '100%',
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
}));


const CountDownButton = ({text = 'Refresh Now', refreshingText = 'Refreshing', seconds, refreshFunc, immediate, variant = "outlined", fullWidth = true, color = "secondary"}) => {

    const classes = useStyles();

    const [lastRefresh, setLastRefresh] = React.useState();
    const [nextRefresh, setNextRefresh] = React.useState();
    const [timeRemaining, setTimeRemaining] = React.useState();
    const [refreshing, setRefreshing] = React.useState();
    const ms = seconds * 1000;

    if (!immediate)
        setNextRefresh(moment().add(seconds, 'seconds'));

    const refreshNow = async () => {
        try {
            setRefreshing(true);
            setTimeRemaining(refreshingText);
            await refreshFunc();
            setNextRefresh(moment().add(seconds, 'seconds'));
        } finally {
            setRefreshing(false);
        }
    }
    useInterval(async () => {
        await refreshNow();
    }, ms, immediate);

    useInterval(async () => {
        if (!refreshing)
            nextRefresh && setTimeRemaining(timeRemainingFormatted(nextRefresh));
        else
            setTimeRemaining(refreshingText);
    }, 500, false);


    // const remainingMsg = timeRemaining ?
    //     timeRemaining.days ? timeRemaining.days + ' days ' : '' +
    //         timeRemaining.hours ? timeRemaining.hours + ' hours ' : '' +
    //     timeRemaining.minutes ? timeRemaining.minutes + ' minutes ' : '' +
    //     timeRemaining.seconds ? timeRemaining.seconds + ' seconds ':'' : '';

    const refreshButtonIcon = (
        <IconButton disabled={refreshing}  color={color}  onClick={async () => await refreshNow()}>
            <RefreshIcon/>
        </IconButton>
    );

    const refreshButton = (
        <Button disabled={refreshing} variant={variant} fullWidth={fullWidth} color={color}
                onClick={async () => await refreshNow()}>{!refreshing ? text : refreshingText}</Button>);

    const gridSubtle = (
        <div>
            <Fab
                color={color}
                onClick={refreshNow}
            >
                <RefreshIcon />
            </Fab>
            {refreshing && <CircularProgress size={68} />}
        </div>
    );

    const grid = (
        <div className={classes.root}>
            <Grid
                container
                direction="column"
                justify="flex-start"
                alignItems="center"
                spacing={1}
            >
                <Grid item xs={12} className={fullWidth ? classes.refreshButtonFullWidth: null}>{refreshButton}</Grid>
                <Grid item><Typography variant="subtitle2" gutterBottom>{timeRemaining}</Typography></Grid>
            </Grid>
        </div>
    );
    return grid;
}

export default CountDownButton;

